export const isAuthEnabled = process.env.NEXT_PUBLIC_AUTH_ENABLED === "true";
